// Importa Leaflet (la variabile L sarà disponibile)
import L from 'leaflet';

// Importa lo stile CSS di Leaflet
import 'leaflet/dist/leaflet.css'; 

// Importa il plugin leaflet-gpx (non restituisce una variabile, si integra su L)
import 'leaflet-gpx';

document.addEventListener('DOMContentLoaded', function() {
	(function(){

		var gpxs = document.querySelectorAll('.smx-block-gpx-map');

		if(gpxs.length > 0){
			window.utils.forEach(gpxs, function (index, gpx) {

				var gpxId = gpx.getAttribute('id'),
					gpxUrl = gpx.getAttribute('data-gpx-url');

				// Inizializza la mappa (scroll disabilitato)
				const map = L.map(gpxId, {
				scrollWheelZoom: false,
				}).setView([45.492676785215735, 12.109981924295425], 13);
		
				// Aggiungi il tile layer (CartoDB Positron)
				L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
				attribution: '&copy; <a href="https://carto.com/">CartoDB</a> contributors',
				maxZoom: 19,
				}).addTo(map);
		
				// Crea il layer GPX e assegnalo a una variabile locale
				const gpxLayer = new L.GPX(gpxUrl, { // eslint-disable-line
				async: true,
				polyline_options: {
					color: '#AE1817', // colore personalizzato
					weight: 5,        // spessore in pixel
					opacity: 1,
				},
				marker_options: {
					shadowUrl: window.baseUrl + '/images/start-icon0.png',
					startIconUrl: window.baseUrl + '/images/start-icon0.png',
					endIconUrl: window.baseUrl + '/images/end-icon0.png',
				},
				}).on('loaded', function(e) {
				// Centra e zooma la mappa per mostrare tutto il percorso,
				// mantenendo un padding e un maxZoom per evitare che diventi troppo piccolo
				map.fitBounds(e.target.getBounds(), {
					padding: [20, 20],
					maxZoom: 15,
				});
				}).addTo(map);

			});
		}
	})();
});